import type { ViewIssueData as IssueServiceViewIssueData } from '@atlassian/jira-issue-fetch-services/src/types';
import type { ViewIssueData } from '@atlassian/jira-issue-view-common-types/src/gira';

export const getIsArchived = (issue: ViewIssueData | IssueServiceViewIssueData): boolean =>
	issue?.isArchived ?? false;
